import React from 'react';
import { Link } from 'react-router-dom';

export default function PageNotFound() {
  return (
    <div className="not-found-page">
      <h1 className="section-title">404 — Page not found</h1>
      <p className="not-found-text">
        This page doesn't exist. Head back home to find what you're looking for.
      </p>
      <Link to="/" className="btn btn-primary">
        Back to home
      </Link>
    </div>
  );
}
